import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PostalCodeForm from '../containers/PostalCodeFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class PostalCodeAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PostalCodeAdd.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('PostalCode_route_add')} />
          <PostalCodeForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PostalCodeAddScreen;

Logger.log('silly', `PostalCodeAddScreen loaded.`);
